// import './wdyr';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import MainApp from './MainApp';
//import * as serviceWorker from './serviceWorker';

window._debug = true;
window._consolaTimer = null;
window._consola = document.getElementById("console");

var noconsole = true;

if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development')) {
  // dev code
} else {
  if(noconsole){
  // production code 
  var _consoleman = function(arg1, type) {
      //alert(txt);
      //console.log(txt);
      var txt = '';
      var size = arg1.length;
      for (var index = 0; index < size; index++) {
        var typ = typeof(arg1[index]);
        if(typ === "object"){
          txt += JSON.stringify(arg1[index]);
        }else{
          txt += arg1[index];
        }
      }

      if(txt === ''){
          return;
      }

      txt = txt.length > 200 ? txt.substring(0, 200)+"..." : txt;
      
      if(window._consola.innerHTML !== ''){
        window._consola.innerHTML += "<br>";
      }

      if(type === 'error'){
        window._consola.innerHTML += '-> <span style="color:red">'+txt+"</span>";
      } else if(type === 'warn'){
        window._consola.innerHTML += '-> <span style="color:yellow">'+txt+"</span>";
      }else{
        window._consola.innerHTML += '-> '+txt;
      }
      window._consola.scrollTop = window._consola.scrollHeight;
  }


  console.log = function log() {
    if(window._debug) {
      _consoleman(arguments, 'log');
      //orig.apply(consoleman, arguments);
    }
  }
  console.error = function error() {
    if(window._debug) {
      _consoleman(arguments, 'error');
      //orig.apply(consoleman, arguments);
    }
  }
  console.warn = function warn() {
    if(window._debug) {
      _consoleman(arguments, 'warn');
      //orig.apply(consoleman, arguments);
    }
  }
  window._consola.addEventListener("click", function(){
    window._consola.style.display = "none";
    window._consolaTimer = setTimeout(function(){ window._consola.style.display = "block"; clearTimeout(window._consolaTimer); }, 5000);
  });
  }
}


ReactDOM.render(
    <React.StrictMode>
      <MainApp />
    </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
